// src/store/slices/filtersSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  search: '',
  status: [],      // multi-select array of status strings
  priority: [],    // multi-select array of priority strings
  assignee: [],    // multi-select array of assignee strings
};

const filtersSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    setSearch(state, action) {
      state.search = action.payload;
    },
    toggleStatusFilter(state, action) {
      const val = action.payload;
      const idx = state.status.indexOf(val);
      if (idx === -1) state.status.push(val);
      else state.status.splice(idx, 1);
    },
    togglePriorityFilter(state, action) {
      const val = action.payload;
      const idx = state.priority.indexOf(val);
      if (idx === -1) state.priority.push(val);
      else state.priority.splice(idx, 1);
    },
    toggleAssigneeFilter(state, action) {
      const val = action.payload;
      const idx = state.assignee.indexOf(val);
      if (idx === -1) state.assignee.push(val);
      else state.assignee.splice(idx, 1);
    },
    clearAllFilters() {
      return initialState;
    },
    setFilters(_, action) {
      return { ...initialState, ...action.payload };
    },
  },
});

export const {
  setSearch,
  toggleStatusFilter,
  togglePriorityFilter,
  toggleAssigneeFilter,
  clearAllFilters,
  setFilters,
} = filtersSlice.actions;

export default filtersSlice.reducer;

// Selectors
export const selectFilters = (state) => state.filters;
export const selectSearchQuery = (state) => state.filters.search;
export const selectStatusFilters = (state) => state.filters.status;
export const selectPriorityFilters = (state) => state.filters.priority;
export const selectAssigneeFilters = (state) => state.filters.assignee;
